import { useTranslation } from 'react-i18next';

export const keyPrefix = 'user_department_list';
export const useUserDepartmentListTranslation = () => useTranslation('widgets', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    title: 'Подразделения',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Departments',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Departamentos',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Departamentos',
  },
}) as Record<string, unknown>;
